module.exports = __webpack_public_path__ + "img/icon-file.0183c3d0.svg";